import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import SystemMark, { BRAND_COLOR, BRAND_RINGS, BRAND_SURFACE } from './SystemMark';

const Navbar = ({ theme, onThemeChange }) => {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <SystemMark
            surface={BRAND_SURFACE}
            color={BRAND_COLOR}
            rings={BRAND_RINGS}
            className="nav-brand-mark"
          />
          <span>timCrider.com</span>
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <NavLink to="/" end className="nav-links">Home</NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/in-practice" className="nav-links">In Practice</NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/cultures" className="nav-links">Cultures</NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/career" className="nav-links">Career</NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/resume" className="nav-links">Resume</NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/homelab" className="nav-links">Homelab</NavLink>
          </li>
        </ul>
        <button className="theme-toggle" type="button" onClick={onThemeChange} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}>
          {theme === 'light' ? <Moon size={18} aria-hidden="true" /> : <Sun size={18} aria-hidden="true" />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;